"use strict";

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.setStyle = setStyle;
exports.getBody = getBody;
exports.releaseIframe = releaseIframe;
exports.exEval = exEval;
exports.getNextBaseZ = getNextBaseZ;
exports.getScroll = getScroll;
exports.getNextTabElement = getNextTabElement;
exports.getDomById = getDomById;
exports.getSize = getSize;
exports.getPos = getPos;
exports.getStyle = exports.once = exports.off = exports.on = exports.trim = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/web.timers.js");

var _vue = _interopRequireDefault(require("vue"));

var _has = _interopRequireDefault(require("./has"));

/* istanbul ignore next */
var body;
var _releaseIframeTimer = null;
var _baseZ = 10000;
var TIMEOUT = 64;
var _releaseIframe = [];
var isServer = _vue["default"].prototype.$isServer;
var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer ? 0 : Number(document.documentMode);
/* istanbul ignore next */

var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */


exports.trim = trim;

var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};
/* istanbul ignore next */


var on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();
/* istanbul ignore next */


exports.on = on;

var off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();
/* istanbul ignore next */


exports.off = off;

var once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }

    off(el, event, listener);
  };

  on(el, event, listener);
};
/* istanbul ignore next */


exports.once = once;

function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');

  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
}
/* istanbul ignore next */


function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }

  if (!el.classList) {
    el.className = curClass;
  }
}
/* istanbul ignore next */


function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }

  if (!el.classList) {
    el.className = trim(curClass);
  }
}
/* istanbul ignore next */


var getStyle = ieVersion < 9 ? function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);

  if (styleName === 'float') {
    styleName = 'styleFloat';
  }

  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }

      default:
        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);

  if (styleName === 'float') {
    styleName = 'cssFloat';
  }

  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};
/* istanbul ignore next */

exports.getStyle = getStyle;

function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if ((0, _typeof2["default"])(styleName) === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);

    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
}

function getBody() {
  if (!body) {
    body = window.jQuery('body');
  }

  return body;
}

function releaseIframe(iframe) {
  _releaseIframe.push(iframe);

  if (_releaseIframeTimer) {
    clearTimeout(_releaseIframeTimer);
  }

  _releaseIframeTimer = setTimeout(releaseIframeDelay, TIMEOUT);
}

function releaseIframeDelay() {
  var iframe;

  while (iframe = _releaseIframe.shift()) {
    iframe.attr({
      src: 'about:blank'
    });
  }

  if ((0, _has["default"])('_isIE')) {
    // eslint-disable-next-line no-useless-catch
    try {
      window.CollectGarbage();
    } catch (exp) {
      throw exp;
    }
  }
}

function exEval(functionNames) {
  var t = functionNames.split(','); // if (!frameName) {
  //   frameName = 'frameContent';
  // }

  for (var i = 0; i < t.length; i++) {
    eval(t[i])();
  }
}

function getNextBaseZ() {
  return _baseZ += 5;
}

function getScroll(el) {
  var scroll = {
    scrollY: false,
    scrollX: false
  };

  if (el.scrollHeight > el.clientHeight) {
    scroll.scrollY = true;
  }

  if (el.offsetHeight - el.clientHeight > 0) {
    scroll.scrollX = true;
  }

  return scroll;
} // export function hasClass(el, cls) {
//   if (!el || !cls) return false
//   if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.')
//   if (el.classList) {
//     return el.classList.contains(cls)
//   } else {
//     return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1
//   }
// }


function getNextTabElement(current, shift) {
  var next;

  while (current) {
    if (!shift) {
      next = current.firstChild || current.nextSibling;

      if (!next) {
        do {
          if ((current = current.parentNode) && current.nodeName === 'BODY') return null;
        } while (!(next = current.nextSibling));
      }
    } else {
      next = current.lastChild || current.previousSibling;

      if (!next) {
        do {
          if ((current = current.parentNode) && current.nodeName === 'BODY') return null;
        } while (!(next = current.previousSibling));
      }
    }

    current = next;
    if (current.nodeName === 'A' || current.nodeName === 'INPUT' || current.nodeName === 'SELECT' || current.nodeName === 'BUTTON' || current.nodeName === 'TEXTAREA') return current;
  }

  return null;
}

function getDomById(id) {
  if (typeof id !== 'string') {
    return id;
  }

  return document.getElementById(id);
}

function getSize(node) {
  return {
    w: node.offsetWidth || node.clientWidth,
    h: node.offsetHeight || node.clientHeight
  };
}

function getPos(node, root) {
  var x = 0,
      y = 0,
      parent,
      doc = document; // nodeRect,
  // rootRect
  // node = node

  root = root || doc.body; // Returns the x, y cordinate for an element on IE 6 and IE 7
  // function getIEPos(node) {
  //   var bodyElm,
  //     rect,
  //     x = 0,
  //     y = 0
  //   if (node) {
  //     rect = node.getBoundingClientRect()
  //     bodyElm = doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body
  //     x = rect.left + bodyElm.scrollLeft
  //     y = rect.top + bodyElm.scrollTop
  //   }
  //   return {
  //     x: x,
  //     y: y
  //   }
  // }
  // Use getBoundingClientRect on IE 6 and IE 7 but not on IE 8 in standards mode
  // if (node && node.getBoundingClientRect && Env.browser === 'IE' && (!doc.documentMode || doc.documentMode < 8)) {
  //   nodeRect = getIEPos(node)
  //   rootRect = getIEPos(root)
  //   return {
  //     x: nodeRect.x - rootRect.x,
  //     y: nodeRect.y - rootRect.y
  //   }
  // }

  parent = node;

  while (parent && parent != root && parent.nodeType) {
    x += parent.offsetLeft || 0;
    y += parent.offsetTop || 0;
    parent = parent.offsetParent;
  }

  parent = node.parentNode;

  while (parent && parent != root && parent.nodeType) {
    x -= parent.scrollLeft || 0;
    y -= parent.scrollTop || 0;
    parent = parent.parentNode;
  }

  return {
    x: x,
    y: y
  };
}